import React, { useState } from 'react';
import './Dropdown.css';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Dropdown } from 'react-bootstrap';
import Icon from '@mui/material/Icon';
import { useTranslation } from 'react-i18next';
import ClickNHold from 'react-click-n-hold';
import { Delete } from 'assets/css/delete-animation';
import Tooltip from 'components/Tooltip';
import { whDropDownItems } from './util';

const Dropdowns = ({ setId, id, deletedIds, setOpenConfigurationPanel }) => {
  const { t } = useTranslation();
  const [anim, setAnim] = useState();
  const [rowID, setRowId] = useState();
  const [show, setShow] = useState(false);

  return (
    <React.Fragment>
      <Dropdown
        onToggle={() => {
          setRowId(id);
          setShow(!show);
        }}
        show={id === rowID && show}
      >
        <Dropdown.Toggle id="dropdown-basic">
          <MoreHorizIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ borderRadius: '10px', boxShadow: 'unset', zIndex: 99999 }} className="menu">
          {whDropDownItems(setOpenConfigurationPanel).map((dropDownItem) => (
            <React.Fragment key={dropDownItem.id}>
              {dropDownItem.name != 'cancel_container' ? (
                <Dropdown.Item
                  style={{ paddingTop: '7px', paddingBottom: '7px', margin: '5px 0' }}
                  className="icon d-flex"
                  onClick={dropDownItem.onClick}
                >
                  <Icon className={dropDownItem.icon} />
                  <p>{t(dropDownItem.lang)}</p>
                </Dropdown.Item>
              ) : (
                <ClickNHold
                  time={2}
                  onStart={() => setAnim(true)}
                  onEnd={() => setAnim(false)}
                  onClickNHold={() => {
                    dropDownItem.onClick();
                    setId([...deletedIds, id]);
                  }}
                >
                  <Tooltip title={t('vs/instance.string54')} placement="left">
                    <Delete anim={anim} className="icon d-flex" style={{ padding: '7px 21px' }}>
                      <Icon className={dropDownItem.icon} />
                      <p>{t(dropDownItem.lang)}</p>
                    </Delete>
                  </Tooltip>
                </ClickNHold>
              )}
            </React.Fragment>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </React.Fragment>
  );
};

export { Dropdowns };
